import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, renderList as _renderList, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11c37b3f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "com_form_contet_admin"
}
const _hoisted_2 = { class: "errorform" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}
const _hoisted_4 = {
  key: 1,
  class: "com_form_contet_admin"
}
const _hoisted_5 = { class: "com_sec1" }
const _hoisted_6 = { class: "inner1" }
const _hoisted_7 = { class: "title_left" }
const _hoisted_8 = {
  key: 0,
  class: "error-message",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "required-mark" }, "※", -1))
const _hoisted_13 = ["max"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "設定対象", -1))
const _hoisted_15 = ["disabled"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label1" }, "デフォルト", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label2" }, "エージェントセグメント", -1))
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { key: 0 }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label2" }, "個別エージェント", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label2" }, "AGコード", -1))
const _hoisted_24 = ["disabled"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "" }
const _hoisted_27 = ["accept"]
const _hoisted_28 = {
  key: 0,
  class: "tableLabel"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label1" }, "現在の設定", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label3" }, "反映日", -1))
const _hoisted_31 = { class: "label3" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "管理ID：", -1))
const _hoisted_33 = {
  class: "table table-bordered",
  id: "nowSetting"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col_selection" }, "削除"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_catgory" }, "カテゴリ"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_iconMenuName" }, "アイコンメニュー名"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_dafaultImg" }, "通常時画像"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_hoverImg" }, "マウスホバー時画像"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_url" }, "リンクURL"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_link" }, "リンク確認"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_dispTarget" }, "表示順"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_separateTab" }, "別タブ表示")
  ])
], -1))
const _hoisted_35 = {
  class: "col_selection",
  "data-name": "mSelection"
}
const _hoisted_36 = ["onUpdate:modelValue"]
const _hoisted_37 = ["onUpdate:modelValue", "onChange"]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_39 = ["value"]
const _hoisted_40 = { class: "unchanged" }
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = { class: "flex-container" }
const _hoisted_43 = { class: "img-group" }
const _hoisted_44 = ["src"]
const _hoisted_45 = ["src"]
const _hoisted_46 = { style: {"text-align":"left"} }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["disabled", "onClick"]
const _hoisted_49 = { class: "flex-container" }
const _hoisted_50 = { class: "img-group" }
const _hoisted_51 = ["src"]
const _hoisted_52 = ["src"]
const _hoisted_53 = { style: {"text-align":"left"} }
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["disabled", "onClick"]
const _hoisted_56 = {
  key: 0,
  class: "unchanged"
}
const _hoisted_57 = ["onUpdate:modelValue"]
const _hoisted_58 = {
  key: 1,
  "data-wrap": "",
  style: {"text-align":"left"}
}
const _hoisted_59 = ["disabled", "onClick"]
const _hoisted_60 = { class: "unchanged" }
const _hoisted_61 = ["onUpdate:modelValue"]
const _hoisted_62 = { class: "form-footer" }
const _hoisted_63 = {
  class: "form-group",
  style: {"text-align":"right"}
}
const _hoisted_64 = {
  key: 0,
  class: "form-group",
  style: {"text-align":"center"}
}
const _hoisted_65 = {
  key: 1,
  class: ""
}
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_67 = {
  key: 0,
  class: "tableLabel"
}
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label1" }, "反映予定の設定", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "label2" }, "反映日", -1))
const _hoisted_70 = ["max"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "管理ID：", -1))
const _hoisted_72 = {
  key: 1,
  class: "table table-bordered"
}
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", { class: "thead-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "col_selection" }, "削除"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_catgory" }, "カテゴリ"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_iconMenuName" }, "アイコンメニュー名"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_dafaultImg" }, "通常時画像"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_hoverImg" }, "マウスホバー時画像"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_url" }, "リンクURL"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_link" }, "リンク確認"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_dispTarget" }, "表示順"),
    /*#__PURE__*/_createElementVNode("th", { class: "col_separateTab" }, "別タブ表示")
  ])
], -1))
const _hoisted_74 = {
  class: "col_selection",
  "data-name": "mSelection"
}
const _hoisted_75 = ["onUpdate:modelValue"]
const _hoisted_76 = ["onUpdate:modelValue", "onChange"]
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, null, -1))
const _hoisted_78 = ["value"]
const _hoisted_79 = { class: "unchanged" }
const _hoisted_80 = ["onUpdate:modelValue"]
const _hoisted_81 = { class: "flex-container" }
const _hoisted_82 = { class: "img-group" }
const _hoisted_83 = ["src"]
const _hoisted_84 = ["src"]
const _hoisted_85 = { style: {"text-align":"left"} }
const _hoisted_86 = ["onClick"]
const _hoisted_87 = ["disabled", "onClick"]
const _hoisted_88 = { class: "flex-container" }
const _hoisted_89 = { class: "img-group" }
const _hoisted_90 = ["src"]
const _hoisted_91 = ["src"]
const _hoisted_92 = { style: {"text-align":"left"} }
const _hoisted_93 = ["onClick"]
const _hoisted_94 = ["disabled", "onClick"]
const _hoisted_95 = {
  key: 0,
  class: "unchanged"
}
const _hoisted_96 = ["onUpdate:modelValue"]
const _hoisted_97 = {
  key: 1,
  "data-wrap": "",
  style: {"text-align":"left"}
}
const _hoisted_98 = ["disabled", "onClick"]
const _hoisted_99 = { class: "unchanged" }
const _hoisted_100 = ["onUpdate:modelValue"]
const _hoisted_101 = {
  class: "form-group",
  style: {"text-align":"right"}
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "※リンクの確認およびプレビューは、入力後、確定をしないと反映されません。", -1))
const _hoisted_103 = { class: "form-inline flex-container" }
const _hoisted_104 = { class: "form-group" }
const _hoisted_105 = { class: "form-group" }
const _hoisted_106 = { class: "form-group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderComponent = _resolveComponent("HeaderComponent")!
  const _component_loading_overlay = _resolveComponent("loading-overlay")!
  const _component_NumericInput = _resolveComponent("NumericInput")!
  const _component_FooterComponent = _resolveComponent("FooterComponent")!
  const _component_BackToTop = _resolveComponent("BackToTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_HeaderComponent, { isAdminPage: true })
    ]),
    _createVNode(_component_loading_overlay, {
      active: _ctx.isLoading,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
      "is-full-page": true
    }, null, 8, ["active"]),
    (_ctx.isInitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, [
                (_ctx.isEditModeUpdate)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode("アイコンメニュー編集")
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("アイコンメニュー登録")
                    ], 64))
              ])
            ]),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", null, [
                _hoisted_10,
                _createTextVNode(" 設定名 "),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  id: "txtSettingName",
                  class: "text1 form-control",
                  maxlength: "255",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.iconMenuKanriData.settingName) = $event)),
                  ref: "txtSettingName"
                }, null, 512), [
                  [_vModelText, _ctx.iconMenuKanriData.settingName]
                ])
              ]),
              (!_ctx.isEditModeUpdate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                    _hoisted_12,
                    _createTextVNode(" 反映日 "),
                    _withDirectives(_createElementVNode("input", {
                      type: "date",
                      id: "reflectionDate",
                      class: "form-control",
                      max: _ctx.AppConstants.MAX_DATE_VALUE,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reflectionDate) = $event))
                    }, null, 8, _hoisted_13), [
                      [_vModelText, _ctx.reflectionDate]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("fieldset", null, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "rdoDefault",
                  name: "targetSetting",
                  class: "form-check-input",
                  value: "0",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.iconMenuKanriData.settingTargetKbn) = $event)),
                  disabled: _ctx.isDefaultId,
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onChangeSettingTarget && _ctx.onChangeSettingTarget(...args)))
                }, null, 40, _hoisted_15), [
                  [_vModelRadio, _ctx.iconMenuKanriData.settingTargetKbn]
                ]),
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "rdoAgsegment",
                  name: "targetSetting",
                  class: "form-check-input",
                  value: "1",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.iconMenuKanriData.settingTargetKbn) = $event)),
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onChangeSettingTarget && _ctx.onChangeSettingTarget(...args)))
                }, null, 544), [
                  [_vModelRadio, _ctx.iconMenuKanriData.settingTargetKbn]
                ]),
                _hoisted_17,
                _withDirectives(_createElementVNode("select", {
                  id: "agSegmentList",
                  class: "select1 form-control",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.iconMenuKanriData.settingTargetCode) = $event)),
                  disabled: !_ctx.isIconMenuTargetSegment
                }, [
                  _hoisted_19,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.agSegmentList, (item) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: item.agSegmentCode,
                      value: item.agSegmentCode
                    }, [
                      (_ctx.isIconMenuTargetSegment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(item.agSegmentCode) + ":" + _toDisplayString(item.agSegmentName), 1))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_20))
                  }), 128))
                ], 8, _hoisted_18), [
                  [_vModelSelect, _ctx.iconMenuKanriData.settingTargetCode]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "rdoKobetuAg",
                  name: "targetSetting",
                  class: "form-check-input",
                  value: "2",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.iconMenuKanriData.settingTargetKbn) = $event)),
                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onChangeSettingTarget && _ctx.onChangeSettingTarget(...args)))
                }, null, 544), [
                  [_vModelRadio, _ctx.iconMenuKanriData.settingTargetKbn]
                ]),
                _hoisted_22,
                _hoisted_23,
                (_ctx.isIconMenuTargetvCode)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      type: "text",
                      id: "txtTitle",
                      class: "text2 form-control",
                      maxlength: "8",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.iconMenuKanriData.settingTargetCode) = $event)),
                      disabled: !_ctx.isIconMenuTargetvCode
                    }, null, 8, _hoisted_24)), [
                      [_vModelText, _ctx.iconMenuKanriData.settingTargetCode]
                    ])
                  : (_openBlock(), _createElementBlock("input", {
                      key: 1,
                      type: "text",
                      id: "txtTitle",
                      class: "text2 form-control",
                      maxlength: "8",
                      disabled: !_ctx.isIconMenuTargetvCode
                    }, null, 8, _hoisted_25))
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("input", {
                type: "file",
                accept: _ctx.iconMenuImgFileExtensions.join(','),
                onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.handleContentsFileSelected && _ctx.handleContentsFileSelected(...args))),
                ref: "iconMenuImgFileInput",
                style: {"display":"none"}
              }, null, 40, _hoisted_27),
              (_ctx.isEditModeUpdate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                    _hoisted_29,
                    _hoisted_30,
                    _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.reflectionDate), 1),
                    _hoisted_32,
                    _createElementVNode("label", null, _toDisplayString(_ctx.iconMenuKanriData.iconMenuKanriId), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("table", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconMenuKanriData.nowSettingList, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.categoryId,
                      style: {"height":"120px"}
                    }, [
                      _createElementVNode("td", _hoisted_35, [
                        _withDirectives(_createElementVNode("input", {
                          id: "mSelection",
                          type: "checkbox",
                          class: "form-check-input",
                          "onUpdate:modelValue": ($event: any) => ((item.selection) = $event)
                        }, null, 8, _hoisted_36), [
                          [_vModelCheckbox, item.selection]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("select", {
                          id: "table",
                          class: "form-control",
                          "onUpdate:modelValue": ($event: any) => ((item.categoryId) = $event),
                          onChange: ($event: any) => (
                    _ctx.changeUrl(
                      item.categoryId,
                      _ctx.IconMenuManegmentConstants.ICONMENU_SETTING_NOW,
                      index
                    )
                  )
                        }, [
                          _hoisted_38,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: item.categoryId,
                              value: item.categoryId
                            }, _toDisplayString(item.categoryName), 9, _hoisted_39))
                          }), 128))
                        ], 40, _hoisted_37), [
                          [_vModelSelect, item.categoryId]
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_40, [
                        _withDirectives(_createElementVNode("input", {
                          style: {"border":"powderblue solid 1px","text-align":"left","padding-left":"8px"},
                          class: "form-control unchanged",
                          id: "dispName",
                          type: "text",
                          maxlength: "15",
                          "onUpdate:modelValue": ($event: any) => ((item.iconMenuName) = $event)
                        }, null, 8, _hoisted_41), [
                          [_vModelText, item.iconMenuName]
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("span", _hoisted_43, [
                            (item.imgPathNomal && !item.previewNomalUrl)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "col_imgCell",
                                  src: 
                        '/WITH_AG_PORTAL/images/' +
                        item.imgPathNomal +
                        '?v=' +
                        new Date().getTime()
                      
                                }, null, 8, _hoisted_44))
                              : _createCommentVNode("", true),
                            (item.previewNomalUrl)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: item.previewNomalUrl,
                                  alt: "1",
                                  class: "col_imgCell"
                                }, null, 8, _hoisted_45))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_46, [
                            _createElementVNode("button", {
                              class: "btn btn-primary btn-sm",
                              onClick: ($event: any) => (
                        _ctx.onContentsFileUpload(
                          _ctx.IconMenuManegmentConstants.ICONMENU_NOW_NOMAL,
                          index
                        )
                      )
                            }, " 参照 ", 8, _hoisted_47),
                            (_ctx.isEditModeUpdate)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  name: "mBtnUpdate",
                                  class: "btn btn-primary btn-sm",
                                  disabled: 
                        _ctx.beforeIconMenuData.nowSettingList[index] == null
                      ,
                                  onClick: _withModifiers(($event: any) => (
                        _ctx.onDownload(
                          _ctx.IconMenuManegmentConstants.ICONMENU_NOW_NOMAL,
                          item.imgPathNomal,
                          index
                        )
                      ), ["prevent"])
                                }, " DL ", 8, _hoisted_48))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("span", _hoisted_50, [
                            (item.imgPathHover && !item.previewHoverUrl)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "col_imgCell",
                                  src: 
                        '/WITH_AG_PORTAL/images/' +
                        item.imgPathHover +
                        '?v=' +
                        new Date().getTime()
                      
                                }, null, 8, _hoisted_51))
                              : _createCommentVNode("", true),
                            (item.previewHoverUrl)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  src: item.previewHoverUrl,
                                  alt: "1",
                                  class: "col_imgCell"
                                }, null, 8, _hoisted_52))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("span", _hoisted_53, [
                            _createElementVNode("button", {
                              type: "button",
                              name: "mBtnUpdate",
                              class: "btn btn-primary btn-sm",
                              onClick: ($event: any) => (
                        _ctx.onContentsFileUpload(
                          _ctx.IconMenuManegmentConstants.ICONMENU_NOW_HOVER,
                          index
                        )
                      )
                            }, " 参照 ", 8, _hoisted_54),
                            (_ctx.isEditModeUpdate)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  name: "mBtnUpdate",
                                  class: "btn btn-primary btn-sm",
                                  disabled: 
                        _ctx.beforeIconMenuData.nowSettingList[index] == null
                      ,
                                  onClick: _withModifiers(($event: any) => (
                        _ctx.onDownload(
                          _ctx.IconMenuManegmentConstants.ICONMENU_NOW_HOVER,
                          item.imgPathHover,
                          index
                        )
                      ), ["prevent"])
                                }, " DL ", 8, _hoisted_55))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      (item.categoryId == _ctx.sonotaCategoryId)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_56, [
                            _withDirectives(_createElementVNode("input", {
                              style: {"border":"powderblue solid 1px","text-align":"left","padding-left":"8px"},
                              class: "form-control unchanged",
                              id: "url",
                              type: "text",
                              maxlength: "255",
                              "onUpdate:modelValue": ($event: any) => ((item.url) = $event)
                            }, null, 8, _hoisted_57), [
                              [_vModelText, item.url]
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("td", _hoisted_58, [
                            _createElementVNode("label", null, _toDisplayString(item.url), 1)
                          ])),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          type: "button",
                          name: "mBtnUpdate",
                          class: "btn btn-primary btn-sm",
                          disabled: item.categoryId != _ctx.sonotaCategoryId,
                          onClick: ($event: any) => (
                    _ctx.onLinkCheck(
                      _ctx.IconMenuManegmentConstants.ICONMENU_SETTING_NOW,
                      item.url,
                      index
                    )
                  )
                        }, " 確認 ", 8, _hoisted_59)
                      ]),
                      _createElementVNode("td", _hoisted_60, [
                        _createVNode(_component_NumericInput, {
                          modelValue: item.dispNo,
                          "onUpdate:modelValue": ($event: any) => ((item.dispNo) = $event),
                          style: {"border":"powderblue solid 1px","text-align":"center","padding-left":"8px"},
                          class: "form-control unchanged",
                          onInput: ($event: any) => (
                    _ctx.numberLimit(
                      _ctx.IconMenuManegmentConstants.ICONMENU_SETTING_NOW,
                      index
                    )
                  )
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _createElementVNode("td", null, [
                        _withDirectives(_createElementVNode("input", {
                          id: "mSelection1",
                          type: "checkbox",
                          class: "form-check-input",
                          name: "nowStting",
                          value: 0,
                          "onUpdate:modelValue": ($event: any) => ((item.isSeparateTab) = $event)
                        }, null, 8, _hoisted_61), [
                          [_vModelCheckbox, item.isSeparateTab]
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnBack",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.rowAdd(_ctx.IconMenuManegmentConstants.ICONMENU_SETTING_NOW)))
                  }, " 行追加 ")
                ]),
                (_ctx.isEditModeUpdate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnBack",
                        class: "btn addbtn btn-primary",
                        onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onCopy && _ctx.onCopy(...args)))
                      }, " 下にコピーする▼ ")
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isEditModeUpdate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    _hoisted_66,
                    (_ctx.isEditModeUpdate)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                          _hoisted_68,
                          _hoisted_69,
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            id: "txtDispDtFrom",
                            class: "inputDate form-control",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.scheduledDate) = $event)),
                            max: _ctx.AppConstants.MAX_DATE_VALUE
                          }, null, 8, _hoisted_70), [
                            [_vModelText, _ctx.scheduledDate]
                          ]),
                          _hoisted_71,
                          _createElementVNode("label", null, _toDisplayString(_ctx.iconMenuKanriData.iconMenuKanriId), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isDataFetched)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_72, [
                          _hoisted_73,
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconMenuKanriData.scheduledSettingList, (item, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: item.categoryId,
                                style: {"height":"120px"}
                              }, [
                                _createElementVNode("td", _hoisted_74, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "mSelection",
                                    type: "checkbox",
                                    class: "form-check-input",
                                    "onUpdate:modelValue": ($event: any) => ((item.selection) = $event)
                                  }, null, 8, _hoisted_75), [
                                    [_vModelCheckbox, item.selection]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("select", {
                                    id: "table",
                                    class: "form-control",
                                    "onUpdate:modelValue": ($event: any) => ((item.categoryId) = $event),
                                    onChange: ($event: any) => (
                      _ctx.changeUrl(
                        item.categoryId,
                        _ctx.IconMenuManegmentConstants.ICONMENU_SETTING_SCHEDULED,
                        index
                      )
                    )
                                  }, [
                                    _hoisted_77,
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryList, (item) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: item.categoryId,
                                        value: item.categoryId
                                      }, _toDisplayString(item.categoryName), 9, _hoisted_78))
                                    }), 128))
                                  ], 40, _hoisted_76), [
                                    [_vModelSelect, item.categoryId]
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_79, [
                                  _withDirectives(_createElementVNode("input", {
                                    style: {"border":"powderblue solid 1px","text-align":"left","padding-left":"8px"},
                                    class: "form-control unchanged",
                                    id: "dispName",
                                    type: "text",
                                    maxlength: "15",
                                    "onUpdate:modelValue": ($event: any) => ((item.iconMenuName) = $event)
                                  }, null, 8, _hoisted_80), [
                                    [_vModelText, item.iconMenuName]
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_81, [
                                    _createElementVNode("span", _hoisted_82, [
                                      (item.imgPathNomal && !item.previewNomalUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            class: "col_imgCell",
                                            src: 
                          '/WITH_AG_PORTAL/images/' +
                          item.imgPathNomal +
                          '?v=' +
                          new Date().getTime()
                        
                                          }, null, 8, _hoisted_83))
                                        : _createCommentVNode("", true),
                                      (item.previewNomalUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            src: item.previewNomalUrl,
                                            alt: "1",
                                            class: "col_imgCell"
                                          }, null, 8, _hoisted_84))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("span", _hoisted_85, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        name: "mBtnUpdate",
                                        class: "btn btn-primary btn-sm",
                                        onClick: ($event: any) => (
                          _ctx.onContentsFileUpload(
                            _ctx.IconMenuManegmentConstants.ICONMENU_SCHEDULED_NOMAL,
                            index
                          )
                        )
                                      }, " 参照 ", 8, _hoisted_86),
                                      (_ctx.isEditModeUpdate)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            name: "mBtnUpdate",
                                            class: "btn btn-primary btn-sm",
                                            disabled: 
                          _ctx.beforeIconMenuData.scheduledSettingList[index] == null
                        ,
                                            onClick: _withModifiers(($event: any) => (
                          _ctx.onDownload(
                            _ctx.IconMenuManegmentConstants.ICONMENU_SCHEDULED_NOMAL,
                            item.imgPathNomal,
                            index
                          )
                        ), ["prevent"])
                                          }, " DL ", 8, _hoisted_87))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_88, [
                                    _createElementVNode("span", _hoisted_89, [
                                      (item.imgPathHover && !item.previewHoverUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            class: "col_imgCell",
                                            src: 
                          '/WITH_AG_PORTAL/images/' +
                          item.imgPathHover +
                          '?v=' +
                          new Date().getTime()
                        
                                          }, null, 8, _hoisted_90))
                                        : _createCommentVNode("", true),
                                      (item.previewHoverUrl)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            src: item.previewHoverUrl,
                                            alt: "1",
                                            class: "col_imgCell"
                                          }, null, 8, _hoisted_91))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("span", _hoisted_92, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        name: "mBtnUpdate",
                                        class: "btn btn-primary btn-sm",
                                        onClick: ($event: any) => (
                          _ctx.onContentsFileUpload(
                            _ctx.IconMenuManegmentConstants.ICONMENU_SCHEDULED_HOVER,
                            index
                          )
                        )
                                      }, " 参照 ", 8, _hoisted_93),
                                      (_ctx.isEditModeUpdate)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            name: "mBtnUpdate",
                                            class: "btn btn-primary btn-sm",
                                            disabled: 
                          _ctx.beforeIconMenuData.scheduledSettingList[index] == null
                        ,
                                            onClick: _withModifiers(($event: any) => (
                          _ctx.onDownload(
                            _ctx.IconMenuManegmentConstants.ICONMENU_SCHEDULED_HOVER,
                            item.imgPathHover,
                            index
                          )
                        ), ["prevent"])
                                          }, " DL ", 8, _hoisted_94))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                (item.categoryId == _ctx.sonotaCategoryId)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_95, [
                                      _withDirectives(_createElementVNode("textarea", {
                                        style: {"border":"powderblue solid 1px","height":"110px","max-width":"100%"},
                                        id: "url",
                                        class: "form-control unchanged",
                                        maxlength: "255",
                                        "onUpdate:modelValue": ($event: any) => ((item.url) = $event)
                                      }, null, 8, _hoisted_96), [
                                        [_vModelText, item.url]
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_97, [
                                      _createElementVNode("label", null, _toDisplayString(item.url), 1)
                                    ])),
                                _createElementVNode("td", null, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    name: "mBtnUpdate",
                                    class: "btn btn-primary btn-sm",
                                    disabled: item.categoryId != _ctx.sonotaCategoryId,
                                    onClick: ($event: any) => (
                      _ctx.onLinkCheck(
                        _ctx.IconMenuManegmentConstants.ICONMENU_SETTING_SCHEDULED,
                        item.url,
                        index
                      )
                    )
                                  }, " 確認 ", 8, _hoisted_98)
                                ]),
                                _createElementVNode("td", _hoisted_99, [
                                  _createVNode(_component_NumericInput, {
                                    modelValue: item.dispNo,
                                    "onUpdate:modelValue": ($event: any) => ((item.dispNo) = $event),
                                    style: {"border":"powderblue solid 1px","text-align":"center","padding-left":"8px"},
                                    class: "form-control unchanged",
                                    onInput: ($event: any) => (
                      _ctx.numberLimit(
                        _ctx.IconMenuManegmentConstants.ICONMENU_SETTING_SCHEDULED,
                        index
                      )
                    )
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                                ]),
                                _createElementVNode("td", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    id: "mSelection2",
                                    type: "checkbox",
                                    class: "form-check-input",
                                    name: "scheduledSetting",
                                    value: 1,
                                    "onUpdate:modelValue": ($event: any) => ((item.isSeparateTab) = $event)
                                  }, null, 8, _hoisted_100), [
                                    [_vModelCheckbox, item.isSeparateTab]
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_101, [
                      _createElementVNode("button", {
                        type: "button",
                        name: "btnBack",
                        class: "btn btn-footer btn-primary",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (
                _ctx.rowAdd(_ctx.IconMenuManegmentConstants.ICONMENU_SETTING_SCHEDULED)
              ))
                      }, " 行追加 ")
                    ]),
                    _hoisted_102
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnDelete",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
                  }, " 行削除 ")
                ]),
                _createElementVNode("div", _hoisted_105, [
                  (_ctx.isEditModeUpdate)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        name: "btnDelete",
                        class: "btn previewbtn btn-primary",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (
                _ctx.onPreview(_ctx.IconMenuManegmentConstants.ICONMENU_SETTING_NOW)
              ))
                      }, " 現在の設定をプレビュー "))
                    : _createCommentVNode("", true),
                  (_ctx.isEditModeUpdate)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        name: "btnDelete",
                        class: "btn previewbtn btn-primary",
                        onClick: _cache[18] || (_cache[18] = ($event: any) => (
                _ctx.onPreview(_ctx.IconMenuManegmentConstants.ICONMENU_SETTING_SCHEDULED)
              ))
                      }, " 反映予定の設定をプレビュー "))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_106, [
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnBack",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, " 戻る "),
                  (!_ctx.isEditModeUpdate)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        name: "btnClear",
                        class: "btn btn-footer btn-primary",
                        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                      }, " クリア "))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    name: "btnAdd",
                    class: "btn btn-footer btn-primary",
                    onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.onFixed && _ctx.onFixed(...args)))
                  }, " 確定 ")
                ])
              ])
            ])
          ])
        ])),
    _createElementVNode("div", null, [
      _createVNode(_component_FooterComponent)
    ]),
    _createVNode(_component_BackToTop)
  ], 64))
}